import { Category } from "../../../models/category.model";

export const learningCategories: Category[] = [
    {
      "Name": "Drafting / Engineering",
      "Sequence": 1,
      "CategoryID": 21,
      "Drafting": true,
      "TaxFree": false,
      "SVG": "''"
    },
    
    {
      "Name": "Foundation",
      "Sequence": 2,
      "CategoryID": 22,
      "Drafting": false,
      "TaxFree": false,
      "SVG": "''"
    },
    {
      "Name": "Structural Features",
      "Sequence": 3,
      "CategoryID": 23,
      "Drafting": false,
      "TaxFree": false,
      "SVG": "''"
    },
    {
      "Name": "Trusses",
      "Sequence": 4,
      "CategoryID": 24,
      "Drafting": false,
      "TaxFree": false,
      "SVG": "''"
    },
    {
      "Name": "Attached Garage",
      "Sequence": 5,
      "CategoryID": 25,
      "Drafting": false,
      "TaxFree": false,
      "SVG": "''"
    },
    {
      "Name": "Roofing",
      "Sequence": 6,
      "CategoryID": 26,
      "Drafting": false,
      "TaxFree": false,
      "SVG": "''"
    },
    {
      "Name": "Porch Covers | Outdoor living Area",
      "Sequence": 7,
      "CategoryID": 27,
      "Drafting": false,
      "TaxFree": false,
      "SVG": "''"
    },
    {
      "Name": "Windows | Skylights",
      "Sequence": 8,
      "CategoryID": 28,
      "Drafting": false,
      "TaxFree": false,
      "SVG": "''"
    },
    {
      "Name": "Exterior Doors",
      "Sequence": 9,
      "CategoryID": 29,
      "Drafting": false,
      "TaxFree": false,
      "SVG": "''"
    },
    {
      "Name": "Siding",
      "Sequence": 10,
      "CategoryID": 30,
      "Drafting": false,
      "TaxFree": false,
      "SVG": "''"
    },
    {
      "Name": "Rough Plumbing",
      "Sequence": 11,
      "CategoryID": 31,
      "Drafting": false,
      "TaxFree": false,
      "SVG": "''"
    },
    {
      "Name": "Rough Electrical",
      "Sequence": 12,
      "CategoryID": 32,
      "Drafting": false,
      "TaxFree": false,
      "SVG": "''"
    },
    {
      "Name": "Finish Electric",
      "Sequence": 13,
      "CategoryID": 33,
      "Drafting": false,
      "TaxFree": false,
      "SVG": "''"
    },
    {
      "Name": "Heating | Cooling",
      "Sequence": 14,
      "CategoryID": 34,
      "Drafting": false,
      "TaxFree": false,
      "SVG": "''"
    },
    {
      "Name": "Ventilation",
      "Sequence": 15,
      "CategoryID": 35,
      "Drafting": false,
      "TaxFree": false,
      "SVG": "''"
    },
    {
      "Name": "Gutters",
      "Sequence": 16,
      "CategoryID": 36,
      "Drafting": false,
      "TaxFree": false,
      "SVG": "''"
    },
    {
      "Name": "Insulation",
      "Sequence": 17,
      "CategoryID": 37,
      "Drafting": false,
      "TaxFree": false,
      "SVG": "''"
    },
    {
      "Name": "Drywall",
      "Sequence": 18,
      "CategoryID": 38,
      "Drafting": false,
      "TaxFree": false,
      "SVG": "''"
    },
    {
      "Name": "Painting",
      "Sequence": 19,
      "CategoryID": 39,
      "Drafting": false,
      "TaxFree": false,
      "SVG": "''"
    },
    {
      "Name": "Cabinets",
      "Sequence": 20,
      "CategoryID": 40,
      "Drafting": false,
      "TaxFree": false,
      "SVG": "''"
    },
    {
      "Name": "Countertops | Sinks",
      "Sequence": 21,
      "CategoryID": 41,
      "Drafting": false,
      "TaxFree": false,
      "SVG": "''"
    },
    {
      "Name": "Finish Plumbing",
      "Sequence": 22,
      "CategoryID": 42,
      "Drafting": false,
      "TaxFree": false,
      "SVG": "''"
    },
    {
      "Name": "Interior Trim | Millwork",
      "Sequence": 23,
      "CategoryID": 43,
      "Drafting": false,
      "TaxFree": false,
      "SVG": "''"
    },
    {
      "Name": "Door Hardware",
      "Sequence": 24,
      "CategoryID": 44,
      "Drafting": false,
      "TaxFree": false,
      "SVG": "''"
    },
    {
      "Name": "Shelving | Mirrors",
      "Sequence": 25,
      "CategoryID": 45,
      "Drafting": false,
      "TaxFree": false,
      "SVG": "''"
    },
    {
      "Name": "Flooring",
      "Sequence": 26,
      "CategoryID": 46,
      "Drafting": false,
      "TaxFree": false,
      "SVG": "''"
    },
    {
      "Name": "Lighting",
      "Sequence": 27,
      "CategoryID": 47,
      "Drafting": false,
      "TaxFree": false,
      "SVG": "''"
    },
    {
      "Name": "Smart Home Automation",
      "Sequence": 28,
      "CategoryID": 48,
      "Drafting": false,
      "TaxFree": false,
      "SVG": "''"
    },
    {
      "Name": "Office | Clerical | Cert. Testing",
      "Sequence": 29,
      "CategoryID": 49,
      "Drafting": false,
      "TaxFree": false,
      "SVG": "''"
    },
    {
      "Name": "Appliances",
      "Sequence": 30,
      "CategoryID": 50,
      "Drafting": false,
      "TaxFree": false,
      "SVG": "''"
    },
    {
      "Name": "Fireplace",
      "Sequence": 31,
      "CategoryID": 51,
      "Drafting": false,
      "TaxFree": false,
      "SVG": "''"
    },
    {
      "Name": "Central Vacuum",
      "Sequence": 32,
      "CategoryID": 52,
      "Drafting": false,
      "TaxFree": false,
      "SVG": "''"
    },
    {
      "Name": "Detached Garage",
      "Sequence": 33,
      "CategoryID": 53,
      "Drafting": false,
      "TaxFree": false,
      "SVG": "''"
    },
    {
      "Name": "CAPS Accessible Features",
      "Sequence": 34,
      "CategoryID": 54,
      "Drafting": false,
      "TaxFree": false,
      "SVG": "''"
    },
    {
      "Name": "Exterior Flatwork",
      "Sequence": 35,
      "CategoryID": 56,
      "Drafting": false,
      "TaxFree": false,
      "SVG": "''"
    },
    {
      "Name": "Solar Power System",
      "Sequence": 36,
      "CategoryID": 582,
      "Drafting": false,
      "TaxFree": false,
      "SVG": "''"
    },
    {
      "Name": "General Conditions",
      "Sequence": 37,
      "CategoryID": 584,
      "Drafting": false,
      "TaxFree": false,
      "SVG": "''"
    },
    {
      "Name": "Site Work",
      "Sequence": 38,
      "CategoryID": 585,
      "Drafting": false,
      "TaxFree": false,
      "SVG": "''"
    }
  ]